import { render, staticRenderFns } from "./AlignBy.vue?vue&type=template&id=76d433ea&scoped=true"
import script from "./AlignBy.vue?vue&type=script&lang=ts"
export * from "./AlignBy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d433ea",
  null
  
)

export default component.exports